import { Grid } from '@mui/material';
import { motion } from 'framer-motion';

import { Skills, Skillsbar, Marquue } from '../../components';
import { interpersonalSkills, interests } from './data';
import profile from '../../assets/anonymous.jpg';
import { aboutAnimation, aboutTransition } from '../../animations/about';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <motion.div
        className="about__wrapper"
        initial="out"
        animate="in"
        variants={aboutAnimation}
        transition={aboutTransition}
      >
        <div className="container">
          <h2 className="about__title">About Me</h2>
          <div className="about__me">
            <img className="about__meImg" src={profile} alt="profile" />
            <div className="about__meInfo">
              <h4>Software Developer</h4>
              <p>
                I am a self-taught software developer with well developed skills
                in frontend and backend software development and have concluded
                various Certifications and Projects in my areas of interest. I'm
                very passionate in writing clean code & always ready to learn. I
                work well in a team but also on my own as I love to set myself
                goals which I will achieve.
              </p>
            </div>
          </div>
        </div>

        <div className="container">
          <h2 className="about__title">Programming Skills</h2>
          <Skillsbar />
        </div>

        <div className="container">
          <h2 className="about__title">Interpersonal Skills</h2>
          <Grid container justify="center" spacing={2}>
            {interpersonalSkills.map((skill) => {
              const { id } = skill;
              return (
                <Grid key={id} item xs={12} sm={6} md={4} lg={3}>
                  <Skills data={skill} />
                </Grid>
              );
            })}
          </Grid>
        </div>

        <div className="container">
          <h2 className="about__title">Interests</h2>
          <Grid container justify="center" spacing={2}>
            {interests.map((skill) => {
              const { id } = skill;
              return (
                <Grid key={id} item xs={12} sm={6} md={4} lg={3}>
                  <Skills data={skill} />
                </Grid>
              );
            })}
          </Grid>
        </div>

        <div>
          <h2 className="about__title">Technologies</h2>
          <Marquue />
        </div>
      </motion.div>
    </div>
  );
};

export default About;
